var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.328 27.5564L4.5 30.3844L14.398 34.6264L18.642 44.5264L21.47 41.6984L20.056 34.6264L26.682 28.0004L33.902 43.4084L36.58 40.7304L34.2 20.4844L39.856 14.8264C40.238 14.4574 40.5428 14.016 40.7524 13.528C40.962 13.04 41.0724 12.5151 41.077 11.984C41.0816 11.4529 40.9804 10.9261 40.7793 10.4346C40.5782 9.94297 40.2812 9.49636 39.9056 9.12079C39.53 8.74522 39.0834 8.44821 38.5918 8.24709C38.1002 8.04596 37.5735 7.94475 37.0424 7.94937C36.5113 7.95399 35.9864 8.06433 35.4984 8.27397C35.0104 8.4836 34.569 8.78833 34.2 9.17037L28.394 14.9764L8.148 12.5944L5.618 15.1264L20.906 22.4664L14.4 28.9724L7.328 27.5564Z",
    fill: "url(#paint0_linear_6216_33506)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6216_33506",
    x1: -62.0073,
    y1: -45.2002,
    x2: 72.777,
    y2: -69.3423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.4f9d51bb912f903542c5e0dd7234f79b.svg";
export { ForwardRef as ReactComponent };